import { render, staticRenderFns } from "./SlideCompareModal.vue?vue&type=template&id=f033542a&scoped=true"
import script from "./SlideCompareModal.vue?vue&type=script&lang=js"
export * from "./SlideCompareModal.vue?vue&type=script&lang=js"
import style0 from "./SlideCompareModal.vue?vue&type=style&index=0&id=f033542a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f033542a",
  null
  
)

export default component.exports